"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadItemInstanceUpdate = void 0;
const ItemInstance_1 = require("../../classes/ItemInstance");
const loadItemInstanceUpdate = (bagItemInstanceUpdate) => {
    new ItemInstance_1.ItemInstance({
        id: bagItemInstanceUpdate.itemInstanceID,
        itemID: bagItemInstanceUpdate.itemID,
    });
};
exports.loadItemInstanceUpdate = loadItemInstanceUpdate;
